
import Vue from "vue";

export default Vue.extend({
  name: "HomePageSection4",

  data: () => ({
    col: "",
    font_title: "",
    width_title: "",
    features: [
      // {
      //   icon: "icon-like",
      //   title: "Prestigio",
      //   font_icon :"70px",
      //   text: "Gran trayectoria de éxitos y miles de egresados trabajando en las mejores empresas con una valiosa y excelente formación.",
      // },
      {
        icon: require("@/assets/icons/beneficios-columbia/like.svg"),
        font_icon: "21px",
        title: "PRESTIGIO",
        text: "Gran trayectoria de éxitos y miles de egresados trabajando en las mejores empresas con una valiosa y excelente formación.",
      },
      {
        icon: require("@/assets/icons/beneficios-columbia/camera.svg"),
        font_icon: "21px",
        title: "MS TEAMS",
        text: "Clases en vivo y sincrónicas para aprendizaje online. Lo mejor y lo último que hay.",
      },
      {
        icon: require("@/assets/icons/beneficios-columbia/lupa.svg"),
        font_icon: "26px",
        title: "COLUMBIA JOBS",
        text: "Las empresas y organizaciones recurren a Columbia Jobs, para reclutar personal calificado y especializado.",
      },
      {
        icon: require("@/assets/icons/beneficios-columbia/books.svg"),
        font_icon: "26px",
        title: "INGLÉS ESPECIALIZADO",
        text: "Reforzamos tu idioma inglés, clases vivenciales. Nueva metodología.",
      },
      {
        icon: require("@/assets/icons/beneficios-columbia/star.svg"),
        font_icon: "26px",
        title: "FORMACIÓN DE CALIDAD",
        text: "Profesores destacados y altamente capacitados. Equipamiento, infraestructura, experiencia y calidad.",
      },
      {
        icon: require("@/assets/icons/beneficios-columbia/network.svg"),
        font_icon: "28px",
        title: "NETWORKING",
        text: "Convenios y afiliaciones nacionales e internacionales. Desarrollo de alianzas y sinergias muy positivas.",
      },
    ],
  }),
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      if (window.innerWidth < 600) {
        this.font_title = "150% !important";
        this.col = "12";
      } else if (window.innerWidth > 1650) {
        this.col = "10";
        this.font_title = "3em !important";
        this.width_title = "100% !important";
      } else {
        this.col = "10";
        this.font_title = "3em !important";
        this.width_title = "100% !important";
      }
    },
  },
});
